import { Record } from 'immutable';

export default class InventoryRecord extends Record({
    id: null,
    order_id: null,
    sale_id: null,
    account_id: null,
    name: '',
    price: 0,
    length: 0,
    condition: null,
    category: null,
    clothing_type: null,
    size: null,
    boot_size: null,
    kids_size: null,
    accessories: null,
    event_type: null,
    boot_type_nordic: null,
    ski_type_nordic: null,
    donate: false,
    discounted: false
  }) {
    get isVendorIdentifer() {
      return this.name === 'identifier';
    }

    order(orders) {
      return orders.get(this.order_id);
    }
  }
